import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { SlCheck } from "react-icons/sl";
import useAuth from "../../hooks/useAuth";
import { addNotice, getNoticeDetail, updateNotice } from "../../services/ api_services";
import useToast from "../../hooks/useToast";
import { ToastTypes } from "../../context/ToastProvider";
import { isEmpty, isObject } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatDate } from "../../core/Util";
import useLoading from "../../hooks/useLoading";
import axios from "axios";

const AddNotice = () => {
    const { auth } = useAuth();
    const { showToast } = useToast(); //등록 시 팝업 표출
    const { loading, setLoading } = useLoading();
    const navigate = useNavigate();

    const initialRequest = {
        seq: null,
        title: "",
        content: "",
        regUserSeq: "",
        upd_dt: "",
        reg_dt: "",
        useYn: "",
        views: 0,
    };

    const sub = {
        title: "",
        button: "",
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["link", "image"],
            [{ align: [] }, { color: [] }, { background: [] }], // dropdown with defaults from theme
            ["clean"],
        ],
    };

    const [request, setRequest] = useState(initialRequest);
    const [Submit, setSubmit] = useState(sub);
    const [searchParams, setSearchParams] = useSearchParams();
    const [adminName, setAdminName] = useState("");

    const ParamsSeq = searchParams.get("id");

    useEffect(() => {
        console.log("🚀 ~ AddNotice ~ useEffect:", ParamsSeq);
        if (ParamsSeq && !isEmpty(ParamsSeq)) {
            noticeDetail();
        }

        divStr();
    }, []);

    useEffect(() => {
        console.log("🚀 ~ AddNotice ~ request:", request);
    }, [request]);

    const noticeDetail = async () => {
        console.log("🚀 ~ Called notice detail ==> ");
        try {
            const response = await getNoticeDetail(ParamsSeq);
            console.log("🚀 ~ noticeDetail ~ response:", response);
            if (response && response.status === 200 && isObject(response.data)) {
                response.data.notice.reg_dt = formatDate(response.data.notice.reg_dt);
                if (response.data.notice.upd_dt) {
                    response.data.notice.upd_dt = formatDate(response.data.notice.upd_dt);
                }
                // console.log("🚀 ~ noticeDetail ~ response.data:", response.data);
                setRequest(response.data.notice);
                setAdminName(response.data.admin_nm);
            } else {
                console.log("INITIAL ==> ");
                setRequest(initialRequest);
            }
        } catch (e) {
            console.log("🚀 ~  ~ response:");
        }
    };
    console.log("seq " + ParamsSeq);

    const checkYn = async () => {
        //사용여부 확인
        try {
            if (request.useYn === "Y") {
                //버튼 누르면 'Y'->'N'으로 바뀜
                setRequest((preVal) => {
                    return {
                        ...preVal,
                        useYn: "N",
                    };
                });
            } else {
                setRequest((preVal) => {
                    return {
                        ...preVal,
                        useYn: "Y",
                    };
                });
            }
        } catch (e) {
            console.log("🚀 ~  ~ response:");
        }
    };

    const updateAPI = async () => {
        try {
            setLoading(true);
            console.log("🚀 ~ updateAPI ~ request:", request);
            const response = await updateNotice(request);
            console.log("🚀 ~ updateAPI ~ response:", response);

            setLoading(false);
            if (response && response.status === 200 && !isEmpty(response.data)) {
                showToast(ToastTypes.SUCCESS, "성공", "공지사항 수정이 완료되었습니다.");
            } else {
                showToast(ToastTypes.ERROR, "오류", "공지사항 수정 중 오류가 발생하였습니다.");
            }
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            } else {
                console.error("Error update notice: ", e);
            }
        }
    };

    const addAPI = async () => {
        setLoading(true);
        console.log("🚀 ~ addAPI ~ request:", request);

        try {
            let requestTmp = request;

            requestTmp.regUserSeq = auth.admin_seq;
            requestTmp.useYn = "Y";
            console.log("🚀 ~ addAPI ~ requestTmp:", requestTmp);
            const response = await addNotice(requestTmp);

            setLoading(false);
            console.log("🚀 ~ addAPI ~ response:", response);
            if (response && response.status === 200 && !isEmpty(response.data)) {
                showToast(ToastTypes.SUCCESS, "성공", "공지사항 등록이 완료되었습니다.");
                navigate("/ad/notice");
            } else {
                showToast(ToastTypes.ERROR, "오류", "공지사항 등록 중 오류가 발생하였습니다.");
            }
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            } else {
                console.error("Error add notice: ", e);
            }
        }
    };

    const handleOnClickButton = async () => {
        console.log("REQUEST ==> ", request);
        if (request.seq) {
            await updateAPI();
        } else {
            await addAPI();
        }
    };

    const divStr = async () => {
        if (ParamsSeq == null) {
            const save = {
                title: "등록",
                button: "등록",
            };
            setSubmit(save);
        } else {
            const update = {
                title: "사항",
                button: "수정",
            };
            setSubmit(update);
        }
    };

    return (
        <div>
            <span className="flex text-center justify-center align-middle text-nowrap text-gray-800 font-semibold text-2xl">
                공지 {Submit.title}
            </span>
            <div className="flex px-2 pb-2 justify-center items-center">
                <div style={{ float: "left", margin: "10px" }}>
                    {!ParamsSeq ? null : (
                        <div className="mb-2 px-1 mt-7 h-8 flex justify-between items-center">
                            <span>
                                <b>작성자</b> | {adminName} &nbsp; <b>등록일</b> | {request.reg_dt} &nbsp; <b>조회수</b> | {request.views}{" "}
                            </span>
                            {auth.admin_seq === request.regUserSeq ? (
                                <div>
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                        checked={request.useYn === "Y"}
                                        onChange={checkYn}
                                    />
                                    <label> 사용 [체크 해제 시 목록에 표시되지 않습니다]</label>
                                </div>
                            ) : null}
                        </div>
                    )}
                    <div className="flex items-center">
                        <input
                            type="text"
                            id="title"
                            placeholder="제목을 입력해 주세요"
                            defaultValue={request.title}
                            className="font-bold block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                            onChange={(e) => {
                                setRequest((preVal) => {
                                    return {
                                        ...preVal,
                                        title: e.target.value,
                                    };
                                });
                            }}
                        />
                    </div>
                    <div className="flex py-4 mb-8 justify-start items-center">
                        <ReactQuill
                            className="rounded-md"
                            value={request.content}
                            style={{ width: "1000px", height: "500px" }}
                            modules={modules}
                            onChange={(e) => {
                                setRequest((preVal) => {
                                    return {
                                        ...preVal,
                                        content: e,
                                    };
                                });
                            }}
                        />
                    </div>
                    {request.upd_dt && ParamsSeq && auth.admin_seq === request.regUserSeq ? (
                        <div className="flex px-1">
                            <p>수정일&nbsp;</p> | {request.upd_dt}
                        </div>
                    ) : null}
                </div>
            </div>
            {/* 버튼 영역 */}
            <div className="mt-5 flex justify-center">
                {auth.admin_seq === request.regUserSeq || ParamsSeq == null ? (
                    <div className="mr-3">
                        <button
                            type="button"
                            className="w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => handleOnClickButton()}
                        >
                            <SlCheck className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            {Submit.button}
                        </button>
                    </div>
                ) : null}

                <div>
                    <button
                        onClick={() => {
                            navigate("/ad/Notice");
                        }}
                        type="button"
                        className="rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100"
                    >
                        목록
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddNotice;
